export function showPrice(subsetOf, value) {
  const price = subsetOf[value] || 0;
  return `${parseInt(price).toLocaleString()} ریال`;
}
